var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { exponentialBackoffDelayMs } from '../../utils/api/apiHelper';
import { getConversationBySlug, getConversationMessages } from './api';
import { mergeMessages } from '../../utils/conversationUtil';
import { sortedByDescending } from '../../utils/arrayUtil';
var MESSAGE_REFRESH_RATE_MS = 30000;
var injectMessages = function (conversation, slug, 
// Use required to force conversationSlug to be non-nullable
messages) {
    // We received messages from the wrong conversation, do nothing
    if (conversation.slug !== slug) {
        console.warn("Received updated messages for another conversation (actual conversation: " + slug + ", expected: " + conversation.slug + "). Skipping");
        return conversation;
    }
    var mergedMessages = mergeMessages(conversation.messages, messages);
    return __assign(__assign({}, conversation), { messages: sortedByDescending(mergedMessages, function (it) { return it.createdOn; }) });
};
/**
 * Retrieves details on the currently focused conversation
 * */
var useCurrentConversation = function (_a) {
    var slug = _a.slug;
    var _b = useQuery(['conversations', slug], function (_a) {
        var queryKey = _a.queryKey;
        // This is the second item from the queryKey
        var conversationSlug = queryKey[1];
        return getConversationBySlug(conversationSlug);
    }, {
        enabled: !!slug,
        retry: 1,
        retryDelay: exponentialBackoffDelayMs,
        staleTime: 1800000,
        // If we experience very high load on our server can this be deactivated,
        // and instead only re-fetch when the user has the window in focus.
        refetchIntervalInBackground: true,
        onError: function (err) {
            console.error('Failed to retrieve messages for conversation', err);
            // TODO(fredrfli) Include Sentry reporting for severe errors
        },
    }), conversation = _b.data, isLoading = _b.isLoading, error = _b.error;
    var _c = useQuery(['conversations', slug, 'messages'], function (_a) {
        var queryKey = _a.queryKey;
        var conversationSlug = queryKey[1];
        return getConversationMessages(conversationSlug);
    }, {
        enabled: !!(conversation === null || conversation === void 0 ? void 0 : conversation.slug),
        retry: 1,
        retryDelay: exponentialBackoffDelayMs,
        refetchInterval: MESSAGE_REFRESH_RATE_MS,
        onError: function (err) {
            console.error("Failed to re-fetch messages for conversation: " + (conversation === null || conversation === void 0 ? void 0 : conversation.slug), err);
        },
    }), _d = _c.data, messages = _d === void 0 ? [] : _d, isRefreshingMessages = _c.isLoading, refreshMessagesError = _c.error;
    var mergedConversation;
    if (conversation && slug) {
        mergedConversation = injectMessages(conversation, slug, messages);
    }
    return {
        isLoading: isLoading,
        isRefreshingMessages: isRefreshingMessages,
        conversation: mergedConversation,
        error: error !== null && error !== void 0 ? error : undefined,
        refreshMessagesError: refreshMessagesError !== null && refreshMessagesError !== void 0 ? refreshMessagesError : undefined,
    };
};
export default useCurrentConversation;
